import m from "./highrise1271.mjs";
import t from "./highrise1272.mjs";
import s from "./highrise1273.mjs";
import f from "./highrise1274.mjs";
import i from "./highrise1275.mjs";
import p from "./highrise1276.mjs";
import J from "./highrise1277.mjs";
import e from "./highrise1278.mjs";
import a from "./highrise1279.mjs";
import c from "./highrise1280.mjs";
import d from "./highrise1281.mjs";
import h from "./highrise1282.mjs";
import l from "./highrise1283.mjs";
import u from "./highrise1284.mjs";
import R from "./highrise1285.mjs";
const r = {
  hr: e,
  da: m,
  nl: d,
  "en-US": s,
  fi: i,
  "fr-CA": p,
  "fr-FR": J,
  de: t,
  hu: a,
  it: c,
  no: h,
  "pt-BR": l,
  "pt-PT": u,
  es: f,
  sv: R
}, M = (n) => {
  const o = r[n];
  return o || r["en-US"];
};
export {
  M as createGHLUIStrings
};
